import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container mar_b" }
const _hoisted_4 = { class: "t6_title_h1" }

import { useRoute,useRouter } from 'vue-router';
    import { reactive,ref } from 'vue';
    import Step1 from './step1/index.vue';
    import Step2 from './step2/index.vue';
    import Step3 from './step3/index.vue';
    import Step4 from './step4/index.vue';
    import Step5 from './step5/index.vue';
    import NextStepButton from './nextStepButton.vue';
    import formData from '@/config/form0';
    import { AREA_ID } from '@/config/const';
    import { queryOneThingData, createProjid, getFormIdByGuideId, queryItemByServiceCode, getFormIdByServiceCode, getServiceMaterialList } from '@/config/request';
    import { ElMessage } from 'element-plus';
    import { useStore } from 'vuex';

    interface checkResultType{
        data: object,   //  当前步骤修改过的 publicData
        status: number  //  验证当前步骤是否符合进入下一步状态 200通过  500不通过
    }

    /**
     * 根据当前步骤保存信息
     */
    
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

    const route = useRoute()
    const store = useStore()
    const router = useRouter()
    console.log('id:', route.query)
    const userInfo = store.state.userInfomation
    console.log('userInfo::',userInfo)

    const step1 = ref()
    const step2 = ref()
    const step3 = ref()
    const step4 = ref()
    const step5 = ref()

    const getStepData = async(val:number) => {
        const stepList = [step1,step2,step3,step4,step5]
        const current = (stepList[data.step-1]).value
        if(data.step < 5){
            let checkResult:checkResultType = await current.check()
            console.log('checkResult',checkResult);

            data.declarationMessage = checkResult.data
            if(checkResult.status === 200){
                console.log('最终data.declarationMessage：',data.declarationMessage)
                formateStep(val)    //  进入下一步
            }
            // 暂时全部可以下一步
            //formateStep(val)
        }else if(data.step === 5){
            router.push('/user-center')
        }

    }

    const data = reactive({
        query:{} as any,
        step:1,
        declarationMessage: JSON.parse(JSON.stringify(formData)),    //  申报过程中的信息，几个申报页面共享
        noform: '0',        // 用来判断是否有表单 0有  1没有
        model: {} as any,
    })
    console.log('data.declarationMessage---刚定义完的空对象',data.declarationMessage)

    const formateStep = (val:number) => {
        if(val < 1){
            val = 1
        }else if(val > 5){
            val = 5
        }
        data.step = val
        document.querySelector('#no_banner')!.scrollIntoView()
    }
    const nextStep = (val:number) => {
        console.log('nextStep：点击下一步')
        let nextVal = ++val
        if(val === 2 && data.noform === '1'){
            nextVal++
        }
        getStepData(nextVal)       //  验证保存数据
    }
    const prevStep = (val:number) => {
        let prevVal = --val
        if(val === 2 && data.noform === '1'){
            prevVal--
        }
        formateStep(prevVal)
    }

    const getQueryData = async() => {
        data.query = route.query
        let routeQuery = route.query as any
        if(routeQuery.ismp === '1'){    //  是秒批申报  查询秒批配置表单
            data.declarationMessage.basicInfo.preApasinfoRelation.sfmptg = 'Y'
        }
        data.declarationMessage.basicInfo.preApasinfo.servicecode = routeQuery.serviceCode;
        data.declarationMessage.basicInfo.preApasinfoRelation.servicecode = routeQuery.serviceCode;
        data.declarationMessage.formJson.serviceCode = routeQuery.serviceCode;
        data.declarationMessage.basicInfo.preApasinfo.servicename = routeQuery.serviceName;
        const res = await queryItemByServiceCode({serviceCode:routeQuery.serviceCode}) as any
        if(res.code === 200 ){
            let lineData = res.result.records[0];  // 当前事项信息
            edit(lineData);
        }

        let type = '1'
        if ('2' == userInfo.usertype) {
            type = '2'
        }
        changeType(type)

    }
    const edit = async(record:any) => {
        data.model = Object.assign({}, record);
        console.log(data.model);
        const res = await getFormIdByServiceCode({serviceCode:data.model.serviceCode}) as any
        if(res.code === 200){
            let thisData = res.result.records;
            // 增加判断表单是否是秒批的表单   formType  默认mr  秒批秒办mpmb
            if(thisData.length > 0){
                let formId1 = ''
                let formId2 = ''
                for(let i = 0; i< thisData.length; i++){
                    if(thisData[i].formType === 'mpmb'){    //  秒批秒单
                        formId1 = thisData[i].formId;
                    }else if(thisData[i].formType === 'mr'){    //  默认
                        formId2 = thisData[i].formId;
                    }
                }
                if(data.declarationMessage.basicInfo.preApasinfoRelation.sfmptg === 'Y'){   //  是秒批申报
                    data.declarationMessage.formJson.formId = formId1;
                    if(!formId1){
                        //ElMessage.warning('未配置表单信息')
                        data.noform = '1';
                    }
                }else{
                    data.declarationMessage.formJson.formId = formId2;
                    if(!formId2){
                        //ElMessage.warning('未配置表单信息')
                        data.noform = '1';
                    }
                }
            }else {
                //ElMessage.warning('未配置表单信息')
                data.noform = '1';
            }
        }
        const result = await createProjid({ areaCode: data.model.areaCode, deptCode: data.model.deptUnid }) as any

        const projid = result.result;
        data.declarationMessage.basicInfo.preApasinfo.projid = projid;
        data.declarationMessage.basicInfo.preApasinfoExt.projid = projid;
        data.declarationMessage.basicInfo.preApasinfoRelation.projid = projid;
        data.declarationMessage.basicInfo.preNode.projid = projid;
        data.declarationMessage.formJson.projid = projid;
        data.declarationMessage.basicInfo.preApasinfoExt.localCatalogCode = projid.substring(projid.length-10,projid.length)

        data.declarationMessage.basicInfo.preApasinfo.serviceversion = data.model.versionNumber;
        data.declarationMessage.basicInfo.preApasinfo.extend = 'I';
        data.declarationMessage.basicInfo.preApasinfo.dataversion = '1';
        data.declarationMessage.basicInfo.preApasinfo.syncStatus = 'I';
        data.declarationMessage.basicInfo.preApasinfo.flowXml = '<?xml version="1.0" encoding="GBK"?><NODES><NODE></NODE></NODES>';
        let code = "";
        for(let i = 1; i <= 6; i++){
            const num = Math.floor(Math.random()*10);
            code += num;
        }
        data.declarationMessage.basicInfo.preApasinfo.projpwd =code;
        data.declarationMessage.basicInfo.preApasinfo.applyfrom='1';
        data.declarationMessage.basicInfo.preApasinfo.qlKind = data.model.serviceType
        data.declarationMessage.basicInfo.preApasinfo.applyPropertiy = '99'
        data.declarationMessage.basicInfo.preApasinfo.busType = '0'
        data.declarationMessage.basicInfo.preApasinfo.deptname = data.model.deptName
        data.declarationMessage.basicInfo.preApasinfo.servicecode = data.model.serviceCode
        data.declarationMessage.basicInfo.preApasinfo.infotype = data.model.infoType
        data.declarationMessage.basicInfo.preApasinfo.servicename = data.model.serviceName
        data.declarationMessage.basicInfo.preApasinfoRelation.promiseDays = data.model.promiseDays
        data.declarationMessage.basicInfo.preApasinfoRelation.legalDays = data.model.legalDays
        data.declarationMessage.basicInfo.preApasinfoRelation.servicecode = data.model.serviceCode
        data.declarationMessage.basicInfo.preApasinfoRelation.formUnid = data.model.formId
        data.declarationMessage.basicInfo.preApasinfo.deptid = data.model.deptid
        data.declarationMessage.basicInfo.preApasinfo.ssOrgcode = data.model.deptCode
        data.declarationMessage.basicInfo.preApasinfo.busMode = '00'
        data.declarationMessage.basicInfo.preApasinfo.isManubrium = '0'
        data.declarationMessage.basicInfo.preApasinfo.areacode = data.model.areacode
        data.declarationMessage.basicInfo.preApasinfo.datastate = '1'
        let name = data.declarationMessage.basicInfo.preApasinfo.servicename;
        data.declarationMessage.basicInfo.preApasinfo.projectname = name+' 的申请';
        data.declarationMessage.pname = data.declarationMessage.basicInfo.preApasinfo.projectname;
        data.declarationMessage.protime = data.model.promiseDays+' (工作日)'

        //实施编码
        data.declarationMessage.basicInfo.preApasinfoExt.taskCode = data.model.implementCode
        data.declarationMessage.basicInfo.preApasinfoExt.syncStatus = 'I'
        data.declarationMessage.basicInfo.preApasinfoExt.contactmanCardtypeCode = '111'
        data.declarationMessage.basicInfo.preApasinfoExt.satisfaction = '5'

        //pre_service_ext表中的数据（已在业务系统处理）
        data.declarationMessage.basicInfo.preApasinfoExt.catalogCode = "";//BASE_CODE
        data.declarationMessage.basicInfo.preApasinfoExt.taskHandleItem = "";//TASKHANDLEITEM
        getMaterialList()
    }

    const changeType = (type:string) => {
        data.declarationMessage.basicInfo.preApasinfo.applyType = type == '1'?'自然人':'企业法人'
        console.log(data.declarationMessage.basicInfo.preApasinfo.applyCardtype)
        if(type == '1'){
            data.declarationMessage.basicInfo.preApasinfo.applyCardtype = '居民身份证'
            data.declarationMessage.basicInfo.preApasinfo.contactmanCardtype = '居民身份证'
        }else{
            data.declarationMessage.basicInfo.preApasinfo.applyCardtype = '统一社会信用代码证'
            data.declarationMessage.basicInfo.preApasinfo.contactmanCardtype = '居民身份证'
        }
    }
    const getMaterialList = async() => {
        let param = {
            pageSize: 80,
            pageNo: 1,
            serviceCode: data.declarationMessage.basicInfo.preApasinfo.servicecode,
            tagName: route.query.tagName,
        } as any
        if(data.query.ismp === '1'){    //  是秒批申报
            param['materialType'] = 'mpmb'
        }

        const res = await getServiceMaterialList(param) as any

        if (res.result.size > 0) {
            let saveMaterials = [] as any;
            let queryMaterials = res.result.records;
            console.log(queryMaterials);
            for (let a = 0; a < queryMaterials.length; a++) {
                let m = {} as any;
                m['copyNum'] = queryMaterials[a].copyNum || ''
                m['importLevel'] = queryMaterials[a].importLevel || ''
                m['memo'] = queryMaterials[a].memo || ''
                m['srcNum'] = queryMaterials[a].srcNum || ''
                m['amount'] = ''
                m['areacode'] = AREA_ID
                m['attrid'] = queryMaterials[a].unid || ''
                m['attrname'] = queryMaterials[a].name || ''
                m['belongsystem'] = data.declarationMessage.basicInfo.preApasinfo.belongsystem
                m['dataversion'] = '1'
                m['exBatch'] = ''
                m['extend'] = queryMaterials[a].sync || ''
                m['fileUrl'] = ''
                m['filename'] = ''
                m['isChecked'] = ''
                m['istake'] = ''
                m['lastUpdateTime'] = ''
                m['projid'] = data.declarationMessage.basicInfo.preApasinfo.projid
                m['sortid'] = queryMaterials[a].sortid
                m['syncStatus'] = ''
                m['taketype'] = 'upload'
                m['unid'] = uuid()
                m['preAttrFiles'] = []  //  申报保存的参数-上传的材料(格式不一样)
                m['preAttrFiles2'] = [] //  存储上传组件上传的材料(格式不一样)
                m['importLevel_dictText'] = queryMaterials[a].importLevel_dictText
                m['fileUrl'] = queryMaterials[a].fileUrl
                m['examplefileUrl'] = queryMaterials[a].examplefileUrl
                saveMaterials.push(m);
            }
            data.declarationMessage.basicInfo.preAttrs = saveMaterials ;

        }else {
            console.log('无材料');
        }

    }

    const uuid = () => {
        let s = [] as any
        let hexDigits = '0123456789abcdef'
        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
        }
        s[14] = '4'
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
        s[8] = s[13] = s[18] = s[23] = '-'

        let uuid = s.join('')
        return uuid
    }
    const init = () => {
        getQueryData()
    }
    init()


    const clickButton=(val:number)=>{
        if(val < 1){
            val = 1;
        }else if(val > 5){
            val = 5
            console.log('跳到用户空间')
        }
        data.step = val
        document.querySelector('#no_banner')!.scrollIntoView()
    }

  
return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[1] || (_cache[1] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "t6_breadCream" }, [
            _createElementVNode("span", null, "首页"),
            _createTextVNode(),
            _createElementVNode("i", null, ">"),
            _createTextVNode(),
            _createElementVNode("span", null, "网上办事"),
            _createTextVNode(),
            _createElementVNode("i", null, ">"),
            _createTextVNode(),
            _createElementVNode("span", null, "事项申报")
          ], -1)),
          _createElementVNode("div", _hoisted_4, _toDisplayString(data.declarationMessage.basicInfo.preApasinfo.servicename), 1),
          _createElementVNode("div", null, [
            (data.step === 1)
              ? (_openBlock(), _createBlock(Step1, {
                  key: 0,
                  ref_key: "step1",
                  ref: step1,
                  publicData: data.declarationMessage
                }, null, 8, ["publicData"]))
              : (data.step === 2)
                ? (_openBlock(), _createBlock(Step2, {
                    key: 1,
                    ref_key: "step2",
                    ref: step2,
                    publicData: data.declarationMessage
                  }, null, 8, ["publicData"]))
                : (data.step === 3)
                  ? (_openBlock(), _createBlock(Step3, {
                      key: 2,
                      ref_key: "step3",
                      ref: step3,
                      publicData: data.declarationMessage
                    }, null, 8, ["publicData"]))
                  : (data.step === 4)
                    ? (_openBlock(), _createBlock(Step4, {
                        key: 3,
                        ref_key: "step4",
                        ref: step4,
                        publicData: data.declarationMessage
                      }, null, 8, ["publicData"]))
                    : (data.step === 5)
                      ? (_openBlock(), _createBlock(Step5, {
                          key: 4,
                          ref_key: "step5",
                          ref: step5,
                          publicData: data.declarationMessage
                        }, null, 8, ["publicData"]))
                      : _createCommentVNode("", true),
            _createVNode(NextStepButton, {
              publicData: data.declarationMessage,
              onNextStep: nextStep,
              onPrevStep: prevStep,
              step: data.step
            }, null, 8, ["publicData", "step"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})